
export interface Member {
  id: string;
  full_name: string;
  phone_number: string;
  email: string | null;
  state: string;
  local_government: string;
  created_at: string;
  nickname?: string | null;
  avatar_url?: string | null;
  invite_count?: number;
  referral_code?: string | null;
  approved?: boolean | null;
  referred_by?: string | null;
  referrer_name?: string | null;
}

export interface FriendRequest {
  id: string;
  requester_id: string;
  recipient_id: string;
  status: 'pending' | 'accepted' | 'rejected';
}

export interface Topic {
  id: string;
  title: string;
  content: string;
  author: {
    id: string;
    name: string;
    avatar: string | null;
  };
  category: string;
  created_at: string;
  reply_count: number;
  view_count: number;
  last_activity: string;
  reactions?: YorubaReaction[];
}

export interface Reply {
  id: string;
  content: string;
  author: {
    id: string;
    name: string;
    avatar: string | null;
  };
  created_at: string;
  likes: number;
  isLiked: boolean;
  reactions?: YorubaReaction[];
}

export interface ReplyComment {
  id: string;
  content: string;
  author: {
    id: string;
    name: string;
    avatar: string | null;
  };
  created_at: string;
  likes: number;
  isLiked: boolean;
  reply_id: string;
  reactions?: YorubaReaction[];
}

// New types for enhanced features
export interface UserXP {
  id: string;
  user_id: string;
  total_xp: number;
  level: number;
  created_at: string;
  updated_at: string;
}

export interface UserBadge {
  id: string;
  user_id: string;
  badge_type: string;
  badge_level: number;
  earned_at: string;
  description: string | null;
}

export interface WeeklyChallenge {
  id: string;
  title: string;
  description: string;
  xp_reward: number;
  start_date: string;
  end_date: string;
  challenge_type: string;
  is_active: boolean;
  created_at: string;
}

export interface UserChallengeProgress {
  id: string;
  user_id: string;
  challenge_id: string;
  completed: boolean;
  progress: number;
  completed_at: string | null;
  created_at: string;
}

export interface HubChat {
  id: string;
  hub_id: string;
  user_id: string;
  message: string;
  message_type: 'text' | 'image' | 'emoji_reaction';
  replied_to: string | null;
  created_at: string;
  updated_at: string;
  author?: {
    id: string;
    name: string;
    avatar: string | null;
  };
}

export interface TypingIndicator {
  id: string;
  hub_id: string;
  user_id: string;
  is_typing: boolean;
  created_at: string;
  expires_at: string;
  author?: {
    name: string;
  };
}

export interface NotificationPreferences {
  id: string;
  user_id: string;
  email_notifications: boolean;
  push_notifications: boolean;
  reply_notifications: boolean;
  new_topic_notifications: boolean;
  chat_notifications: boolean;
  referral_notifications: boolean;
  challenge_notifications: boolean;
  created_at: string;
}

export interface FollowedHub {
  id: string;
  user_id: string;
  hub_type: 'topic' | 'state' | 'lga' | 'general';
  hub_id: string;
  followed_at: string;
}

export interface UserOnboarding {
  id: string;
  user_id: string;
  completed_steps: string[];
  completed: boolean;
  created_at: string;
  updated_at: string;
}

export interface YorubaReaction {
  id: string;
  user_id: string;
  target_type: 'topic' | 'reply' | 'comment' | 'chat';
  target_id: string;
  reaction_type: 'mo_gbadun' | 'koko' | 'se_o_ri' | 'ewo' | 'oya_now';
  created_at: string;
  author?: {
    name: string;
  };
}

export type YorubaReactionType = 'mo_gbadun' | 'koko' | 'se_o_ri' | 'ewo' | 'oya_now';

export const YORUBA_REACTIONS: Record<YorubaReactionType, { emoji: string; label: string; description: string }> = {
  mo_gbadun: { emoji: '😍', label: 'Mo gbádùn', description: 'I love it!' },
  koko: { emoji: '🔥', label: 'Kókó', description: 'This is fire!' },
  se_o_ri: { emoji: '👀', label: 'Ṣé o rí?', description: 'Did you see this?' },
  ewo: { emoji: '😱', label: 'Èèwọ̀', description: 'Wow/Amazing!' },
  oya_now: { emoji: '⚡', label: 'Óya now', description: 'Let\'s go!' }
};
